import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { RECORD_EVENT_REQUEST } from 'redux/analytics/constants';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listClubs, getClub } from './api';
import {
  LIST_CLUBS_REQUEST,
  GET_CLUB_REQUEST,
  GET_CLUB_SUCCESS,
  CLUB_LIST_REQUESTING,
  CLUB_OBJECT_REQUESTING,
  LIST_CLUBS_SUCCESS,
  RESET_CLUB_ISFETCHING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_LIST_REQUESTING });
    const response = yield call(listClubs);

    yield put({ type: LIST_CLUBS_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubList',
      payload: response.data.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_OBJECT_REQUESTING });
    const response = yield call(getClub, action.slug);
    yield put({ type: GET_CLUB_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubDetail',
      payload: response.data
    });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
  return null;
}

function* watchList() {
  yield takeLatest(LIST_CLUBS_REQUEST, list);
  yield takeEvery(GET_CLUB_REQUEST, get);
}

export default function* clubSagas() {
  yield all([watchList()]);
}
